import { observable, action } from 'mobx';

import { SerializedData, Store } from 'bernie-core';
import { Logger, NOOP_LOGGER } from 'bernie-logger';

export class AdvertisingStore extends Store {
  constructor(state: SerializedData = {}, logger: Logger = NOOP_LOGGER) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  public static DEFAULTS = {
    adsloader: '',
    adsloaderes5: '',
    pageName: undefined,
    clAdsVisible: true
  };

  @observable
  public adsloader: string;
  @observable
  public adsloaderes5: string;
  @observable
  public pageName: string;
  @observable
  public clAdsVisible: boolean;

  @action
  public setPageName(pageName: string) {
    this.pageName = pageName;
  }
  @action
  public showCLAds(value) {
    this.clAdsVisible = value;
  }
  @action
  public displayAdRefresh() {
    document.dispatchEvent(new CustomEvent('DisplayAdRefresh'));
  }
}
